module.exports = __webpack_public_path__ + "static/media/node.573818b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/node.png
// module id = 333
// module chunks = 0